import type { ReactNode } from 'react';

export interface PageLayoutProps {
  readonly title: string;
  readonly actions?: ReactNode;
  readonly children?: ReactNode;
}

/** Page frame: one h1, an action area and a main region [02 §18]. */
export function PageLayout({ title, actions, children }: PageLayoutProps) {
  return (
    <section className="skm-page" aria-labelledby="skm-page-title">
      <header className="skm-page__header">
        <h1 id="skm-page-title">{title}</h1>
        {actions ? <div className="skm-page__actions">{actions}</div> : null}
      </header>
      <div className="skm-page__body">{children}</div>
    </section>
  );
}
